import { Amplify } from 'aws-amplify'

import amplifyConfiguration from '~/amplifyconfiguration.json'

const authConfig = () => {
  const updatedExports = {
    ...amplifyConfiguration,
    oauth: {
      ...amplifyConfiguration.oauth,
      redirectSignIn: `${window.location.origin}/`,
      redirectSignOut: `${window.location.origin}/`,
    },
  }

  Amplify.configure(updatedExports)
}

export default authConfig
